import { NgModule } from '@angular/core';
import { ImageAsyncDirective } from './directives/image-async.directive';
import { ShowSpinnerDirective } from './directives/show-spinner.directive';
import { MatSpinnerContainerComponent } from './components/mat-spinner-container/mat-spinner-container.component';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';

@NgModule({
    declarations: [ImageAsyncDirective, MatSpinnerContainerComponent, ShowSpinnerDirective],
    exports: [ImageAsyncDirective, ShowSpinnerDirective, MatSpinnerContainerComponent],
    imports: [MatProgressSpinnerModule],
})
export class DirectivesModule {}
